import { Modal } from "antd";
import styled from "styled-components";

export const CommonModalWrapper = styled(Modal)`
  .common-modal {
  }
  .ant-modal-header {
    margin-bottom: 0;
    padding: 16px 24px;
    background: none;

    .ant-modal-title {
      display: flex;
      align-items: center;
      column-gap: 12px;

      button {
        width: 48px;
        height: 48px;
        background-color: #edeff1;
        border-radius: 100%;
        border: none;
        position: relative;
        cursor: pointer;

        svg {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }

      span {
        font-weight: var(--font-bold);
        font-size: var(--font-size-base);
        line-height: 24px;
      }
    }
  }

  .ant-modal-content {
    padding: 0;
    background: var(--color-white);
    box-shadow: 0px 2px 8px 0px rgba(5, 40, 97, 0.08);
    border-radius: 12px;
  }

  .ant-modal-footer {
    padding: 10px 24px 24px;
    .btn-next {
      width: 50px;
      font-weight: 700;
      color: var(--color-white);
      border-color: 1px solid var(--color-primary);
      background: var(--color-primary);
      &:hover {
        background-color: var(--color-hover-primary) !important;
        border-color: 1px solid var(--color-primary) !important;
        color: var(--color-primary) !important;
      }
    }
    .btn-next-disable {
      width: 368px;
      height: 48px;
      box-shadow: none;
      font-weight: var(--font-bold);
      margin-inline-start: 0;
      background-color: #eaecf0;
      color: #98a2b3;
    }

    .ant-btn {
      width: 100%;
      height: 48px;
      box-shadow: none;
      font-weight: var(--font-bold);
      margin-inline-start: 0;
    }
    .cancel-btn {
      color: var(--color-primary);
      border-color: var(--color-primary);
      &:hover {
        background-color: var(--color-hover-primary) !important;
        border-color: var(--color-hover-primary) !important;
        color: #ffffff !important;
      }
    }
    .close-btn {
      color: var(--color-primary);
      width: 100%;
      border-color: var(--color-primary);
      &:hover {
        background-color: var(--color-hover-primary) !important;
        border-color: var(--color-hover-primary) !important;
        color: #ffffff !important;
      }
    }

    .ant-btn-primary {
      margin-inline-start: 0 !important;
    }
  }

  .ant-modal-body {
    padding: 16px 24px;
    border-bottom: 1px solid #f1f3f7;
    border-top: 1px solid #f1f3f7;
    form {
      .ant-select-open .ant-select-selector {
        border-width: 2px !important;
        border-color: var(--color-primary) !important;
        box-shadow: 0px 0px 0px 2px #fd980033 !important;
        outline: none !important;
      }
      .ant-picker-outlined:focus-within {
        border-width: 2px !important;
        border-color: var(--color-primary) !important;
        box-shadow: 0px 0px 0px 2px #fd980033 !important;
        outline: none !important;
      }
      .ant-select-focused .ant-select-selector,
      .ant-select-open .ant-select-selector {
        border-width: 2px !important;
        border-color: var(--color-primary) !important;
        box-shadow: 0px 0px 0px 2px #fd980033 !important;
        outline: none !important;
      }
      .ant-input-outlined:focus-within {
        border-width: 2px !important;
        border-color: var(--color-primary) !important;
        box-shadow: 0px 0px 0px 2px #fd980033 !important;
        outline: none !important;
      }
      .ant-input-disabled {
        background-color: var(--color-border-secondary) !important;
        color: var(--color-secondary) !important;
        border-color: var(--color-border-secondary) !important;
        cursor: not-allowed;
      }
      .ant-select-disabled > .ant-select-selector {
        border-radius: 8px;
        background-color: var(--color-border-secondary) !important;
        color: var(--color-secondary) !important;
        border-color: var(--color-border-secondary) !important;
        cursor: not-allowed;
      }
      .ant-select-selector {
        .ant-select-selection-search {
          .ant-select-selection-search-input {
            height: 100%;
            font-size: var(--font-size-xl);
            font-weight: var(--font-medium);
          }
        }
      }
      .ant-select-lg,
      .ant-input-lg,
      .ant-input-password,
      .ant-input-number-lg {
        height: 56px;
      }
      .ant-select-arrow {
        top: 45%;
        margin-top: 0;
        height: 6px;
        font-size: 12px;
        color: var(--color-text-primary);
        inset-inline-end: 16px;
      }
      .second-row {
        margin-top: -17px;
      }
    }
  }
`;
